import React from 'react'

function TokenomicsTwo() {
    return (
        <>
            {/* Tokenomics area Start */}
            <section
                id="tokenomics"
                className="rts-tokenomics-area area-two rts-section-gap"
            >
                <div className="container">
                    <div className="section-title-area2">
                        <p
                            className="sub-title wow fadeInUp"
                            data-wow-delay=".2s"
                            data-wow-duration="2s"
                        >
                            Get it Now On
                        </p>
                        <h2
                            className="section-title wow fadeInUp"
                            data-wow-delay=".5s"
                            data-wow-duration="2s"
                        >
                            Browse Trending Coin{" "}
                        </h2>
                    </div>
                    <div className="section-inner mt--50">
                        <ul className="rts-tokenomics-list-area">
                            <li
                                className="wow zoomIn"
                                data-wow-delay=".6s"
                                data-wow-duration="1s"
                            >
                                10% <span>Liquidity Pool</span>
                            </li>
                            <li
                                className="wow zoomIn"
                                data-wow-delay=".7s"
                                data-wow-duration="1s"
                            >
                                30% <span>Marketing</span>
                            </li>
                            <li
                                className="wow zoomIn"
                                data-wow-delay=".8s"
                                data-wow-duration="1s"
                            >
                                5% <span>Reserve</span>
                            </li>
                            <li
                                className="wow zoomIn"
                                data-wow-delay=".9s"
                                data-wow-duration="1s"
                            >
                                10% <span>Innovation</span>
                            </li>
                            <li className="wow zoomIn" data-wow-delay="1s" data-wow-duration="1s">
                                5% <span>Development</span>
                            </li>
                            <li
                                className="wow zoomIn"
                                data-wow-delay="1.1s"
                                data-wow-duration="1s"
                            >
                                5% <span>Advisors</span>
                            </li>
                            <li
                                className="wow zoomIn"
                                data-wow-delay="1.2s"
                                data-wow-duration="1s"
                            >
                                5% <span>Liquidity Pool</span>
                            </li>
                        </ul>
                    </div>
                </div>
            </section>
            {/* Tokenomics area End */}
        </>

    )
}

export default TokenomicsTwo